var _metadata, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    id: "svg2",
    width: 135.716,
    height: 40.019,
    viewBox: "0 0 135.716 40.019",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient50",
    x1: 31.8,
    x2: 15.017,
    y1: 183.29,
    y2: 166.508,
    gradientTransform: "matrix(0.8,0,0,-0.8,0,161.6)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop52",
    offset: 0,
    stopColor: "#00a0ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop54",
    offset: 0.007,
    stopColor: "#00a1ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop56",
    offset: 0.26,
    stopColor: "#00beff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop58",
    offset: 0.512,
    stopColor: "#00d2ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop60",
    offset: 0.76,
    stopColor: "#00dfff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop62",
    offset: 1,
    stopColor: "#00e3ff",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient68",
    x1: 43.834,
    x2: 19.638,
    y1: 171.999,
    y2: 171.999,
    gradientTransform: "matrix(0.8,0,0,-0.8,0,161.6)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop70",
    offset: 0,
    stopColor: "#ffe000",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop72",
    offset: 0.409,
    stopColor: "#ffbd00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop74",
    offset: 0.775,
    stopColor: "orange",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop76",
    offset: 1,
    stopColor: "#ff9c00",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient82",
    x1: 34.827,
    x2: 12.069,
    y1: 169.704,
    y2: 146.946,
    gradientTransform: "matrix(0.8,0,0,-0.8,0,161.6)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop84",
    offset: 0,
    stopColor: "#ff3a44",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop86",
    offset: 1,
    stopColor: "#c31162",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient92",
    x1: 17.297,
    x2: 27.46,
    y1: 191.824,
    y2: 181.661,
    gradientTransform: "matrix(0.8,0,0,-0.8,0,161.6)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop94",
    offset: 0,
    stopColor: "#32a071",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop96",
    offset: 0.069,
    stopColor: "#2da771",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop98",
    offset: 0.476,
    stopColor: "#15cf74",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop100",
    offset: 0.801,
    stopColor: "#06e775",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop102",
    offset: 1,
    stopColor: "#00f076",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath110",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask114",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g118",
    clipPath: "url(#clipPath110)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path120",
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "nonzero",
    stroke: "none",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath126",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath130",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern134",
    width: 124,
    height: 48,
    x: 0,
    y: 0,
    patternTransform: "matrix(1,0,0,-1,0,48)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g140",
    clipPath: "url(#clipPath130)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path144",
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M 29.625,20.695 18.012,14.098 C 17.363,13.727 16.781,13.754 16.406,14.09 l -0.058,-0.063 0.058,-0.058 c 0.375,-0.336 0.957,-0.36 1.606,0.011 l 11.687,6.641 -0.074,0.074 z"
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath158",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask162",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g166",
    clipPath: "url(#clipPath158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path168",
    fill: "#000",
    fillOpacity: 0.12,
    fillRule: "nonzero",
    stroke: "none",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath174",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath178",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path180",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern182",
    width: 124,
    height: 48,
    x: 0,
    y: 0,
    patternTransform: "matrix(1,0,0,-1,0,48)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g188",
    clipPath: "url(#clipPath178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path192",
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 16.348,14.145 c -0.235,0.246 -0.371,0.628 -0.371,1.125 l 0,-0.118 c 0,-0.496 0.136,-0.879 0.371,-1.125 l 0.058,0.063 -0.058,0.055 z"
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath206",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path208",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask210",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g214",
    clipPath: "url(#clipPath206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path216",
    fill: "#000",
    fillOpacity: 0.12,
    fillRule: "nonzero",
    stroke: "none",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath222",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path224",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath226",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path228",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern230",
    width: 124,
    height: 48,
    x: 0,
    y: 0,
    patternTransform: "matrix(1,0,0,-1,0,48)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g236",
    clipPath: "url(#clipPath226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path240",
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 33.613,22.961 -3.988,-2.266 0.074,-0.074 3.914,2.223 c 0.559,0.316 0.836,0.734 0.836,1.156 -0.047,-0.379 -0.332,-0.75 -0.836,-1.039 z"
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath254",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path256",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask258",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g262",
    clipPath: "url(#clipPath254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path264",
    fill: "#000",
    fillOpacity: 0.25,
    fillRule: "nonzero",
    stroke: "none",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath270",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path272",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath274",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path276",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern278",
    width: 124,
    height: 48,
    x: 0,
    y: 0,
    patternTransform: "matrix(1,0,0,-1,0,48)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g284",
    clipPath: "url(#clipPath274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path288",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 18.012,33.902 15.601,-8.863 c 0.508,-0.289 0.789,-0.66 0.836,-1.039 0,0.418 -0.277,0.836 -0.836,1.156 L 18.012,34.02 c -1.117,0.632 -2.035,0.105 -2.035,-1.176 l 0,-0.114 c 0,1.278 0.918,1.805 2.035,1.172 z"
  }))))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.25,0,0,-1.25,-9.4247625,49.85025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "matrix(1.0023923,0,0,0.99072975,-0.29664807,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M 112,8 12,8 C 9.801,8 8,9.801 8,12 l 0,24 c 0,2.199 1.801,4 4,4 l 100,0 c 2.199,0 4,-1.801 4,-4 l 0,-24 c 0,-2.199 -1.801,-4 -4,-4 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    fill: "#a6a6a6",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 112,39.359 c 1.852,0 3.359,-1.507 3.359,-3.359 l 0,-24 c 0,-1.852 -1.507,-3.359 -3.359,-3.359 l -100,0 c -1.852,0 -3.359,1.507 -3.359,3.359 l 0,24 c 0,1.852 1.507,3.359 3.359,3.359 l 100,0 M 112,40 12,40 C 9.801,40 8,38.199 8,36 L 8,12 C 8,9.801 9.801,8 12,8 l 100,0 c 2.199,0 4,1.801 4,4 l 0,24 c 0,2.199 -1.801,4 -4,4 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "matrix(1,0,0,-1,0,48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 0.16,
    d: "m 45.934,16.195 c 0,0.668 -0.2,1.203 -0.594,1.602 -0.453,0.473 -1.043,0.711 -1.766,0.711 -0.691,0 -1.281,-0.242 -1.765,-0.719 -0.485,-0.484 -0.727,-1.078 -0.727,-1.789 0,-0.711 0.242,-1.305 0.727,-1.785 0.484,-0.481 1.074,-0.723 1.765,-0.723 0.344,0 0.672,0.071 0.985,0.203 0.312,0.133 0.566,0.313 0.75,0.535 l -0.418,0.422 c -0.321,-0.379 -0.758,-0.566 -1.317,-0.566 -0.504,0 -0.941,0.176 -1.312,0.531 -0.367,0.356 -0.551,0.817 -0.551,1.383 0,0.566 0.184,1.031 0.551,1.387 0.371,0.351 0.808,0.531 1.312,0.531 0.535,0 0.985,-0.18 1.34,-0.535 0.234,-0.235 0.367,-0.559 0.402,-0.973 l -1.742,0 0,-0.578 2.324,0 c 0.028,0.125 0.036,0.246 0.036,0.363 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "matrix(1,0,0,-1,0,48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 0.16,
    d: "m 49.621,14.191 -2.183,0 0,1.52 1.968,0 0,0.578 -1.968,0 0,1.52 2.183,0 0,0.589 -2.801,0 0,-4.796 2.801,0 0,0.589 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "matrix(1,0,0,-1,0,48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 0.16,
    d: "m 52.223,18.398 -0.618,0 0,-4.207 -1.339,0 0,-0.589 3.297,0 0,0.589 -1.34,0 0,4.207 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "matrix(1,0,0,-1,0,48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 0.16,
    d: "m 55.949,18.398 0,-4.796 0.617,0 0,4.796 -0.617,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "matrix(1,0,0,-1,0,48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 0.16,
    d: "m 59.301,18.398 -0.613,0 0,-4.207 -1.344,0 0,-0.589 3.301,0 0,0.589 -1.344,0 0,4.207 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "matrix(1,0,0,-1,0,48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 0.16,
    d: "m 66.887,17.781 c -0.473,0.485 -1.059,0.727 -1.758,0.727 -0.703,0 -1.289,-0.242 -1.762,-0.727 C 62.895,17.297 62.66,16.703 62.66,16 c 0,-0.703 0.235,-1.297 0.707,-1.781 0.473,-0.485 1.059,-0.727 1.762,-0.727 0.695,0 1.281,0.242 1.754,0.731 0.476,0.488 0.711,1.078 0.711,1.777 0,0.703 -0.235,1.297 -0.707,1.781 z m -3.063,-0.402 c 0.356,0.359 0.789,0.539 1.305,0.539 0.512,0 0.949,-0.18 1.301,-0.539 0.355,-0.359 0.535,-0.82 0.535,-1.379 0,-0.559 -0.18,-1.02 -0.535,-1.379 -0.352,-0.359 -0.789,-0.539 -1.301,-0.539 -0.516,0 -0.949,0.18 -1.305,0.539 -0.355,0.359 -0.535,0.82 -0.535,1.379 0,0.559 0.18,1.02 0.535,1.379 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42",
    transform: "matrix(1,0,0,-1,0,48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path44",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 0.16,
    d: "m 68.461,18.398 0,-4.796 0.75,0 2.332,3.73 0.027,0 -0.027,-0.922 0,-2.808 0.617,0 0,4.796 -0.644,0 -2.442,-3.914 -0.027,0 0.027,0.926 0,2.988 -0.613,0 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 62.508,22.598 c -1.879,0 -3.414,-1.43 -3.414,-3.403 0,-1.957 1.535,-3.402 3.414,-3.402 1.883,0 3.418,1.445 3.418,3.402 0,1.973 -1.535,3.403 -3.418,3.403 z m 0,-5.465 c -1.031,0 -1.918,0.851 -1.918,2.062 0,1.227 0.887,2.063 1.918,2.063 1.031,0 1.922,-0.836 1.922,-2.063 0,-1.211 -0.891,-2.062 -1.922,-2.062 z m -7.449,5.465 c -1.883,0 -3.414,-1.43 -3.414,-3.403 0,-1.957 1.531,-3.402 3.414,-3.402 1.882,0 3.414,1.445 3.414,3.402 0,1.973 -1.532,3.403 -3.414,3.403 z m 0,-5.465 c -1.032,0 -1.922,0.851 -1.922,2.062 0,1.227 0.89,2.063 1.922,2.063 1.031,0 1.918,-0.836 1.918,-2.063 0,-1.211 -0.887,-2.062 -1.918,-2.062 z m -8.864,4.422 0,-1.446 3.453,0 c -0.101,-0.808 -0.371,-1.402 -0.785,-1.816 -0.504,-0.5 -1.289,-1.055 -2.668,-1.055 -2.125,0 -3.789,1.715 -3.789,3.84 0,2.125 1.664,3.84 3.789,3.84 1.149,0 1.985,-0.449 2.602,-1.031 l 1.019,1.019 c -0.863,0.824 -2.011,1.457 -3.621,1.457 -2.914,0 -5.363,-2.371 -5.363,-5.285 0,-2.914 2.449,-5.285 5.363,-5.285 1.575,0 2.758,0.516 3.688,1.484 0.953,0.953 1.25,2.293 1.25,3.375 0,0.336 -0.028,0.645 -0.078,0.903 l -4.86,0 z m 36.246,-1.121 c -0.281,0.761 -1.148,2.164 -2.914,2.164 -1.75,0 -3.207,-1.379 -3.207,-3.403 0,-1.906 1.442,-3.402 3.375,-3.402 1.563,0 2.465,0.953 2.836,1.508 l -1.16,0.773 c -0.387,-0.566 -0.914,-0.941 -1.676,-0.941 -0.757,0 -1.3,0.347 -1.648,1.031 l 4.551,1.883 -0.157,0.387 z m -4.64,-1.133 c -0.039,1.312 1.019,1.984 1.777,1.984 0.594,0 1.098,-0.297 1.266,-0.722 L 77.801,19.301 Z M 74.102,16 l 1.496,0 0,10 -1.496,0 0,-10 z m -2.45,5.84 -0.05,0 c -0.336,0.398 -0.977,0.758 -1.789,0.758 -1.704,0 -3.262,-1.496 -3.262,-3.414 0,-1.907 1.558,-3.391 3.262,-3.391 0.812,0 1.453,0.363 1.789,0.773 l 0.05,0 0,-0.488 c 0,-1.301 -0.695,-2 -1.816,-2 -0.914,0 -1.481,0.66 -1.715,1.215 L 66.82,14.75 c 0.375,-0.902 1.368,-2.012 3.016,-2.012 1.754,0 3.234,1.032 3.234,3.543 l 0,6.11 -1.418,0 0,-0.551 z m -1.711,-4.707 c -1.031,0 -1.894,0.863 -1.894,2.051 0,1.199 0.863,2.074 1.894,2.074 1.016,0 1.817,-0.875 1.817,-2.074 0,-1.188 -0.801,-2.051 -1.817,-2.051 z M 89.445,26 l -3.578,0 0,-10 1.492,0 0,3.789 2.086,0 c 1.657,0 3.282,1.199 3.282,3.106 0,1.906 -1.629,3.105 -3.282,3.105 z m 0.039,-4.82 -2.125,0 0,3.429 2.125,0 c 1.114,0 1.75,-0.925 1.75,-1.714 0,-0.774 -0.636,-1.715 -1.75,-1.715 z m 9.223,1.437 c -1.078,0 -2.199,-0.476 -2.66,-1.531 l 1.324,-0.555 c 0.285,0.555 0.809,0.735 1.363,0.735 0.774,0 1.559,-0.465 1.571,-1.286 l 0,-0.105 c -0.27,0.156 -0.848,0.387 -1.559,0.387 -1.426,0 -2.879,-0.785 -2.879,-2.25 0,-1.34 1.168,-2.203 2.481,-2.203 1.004,0 1.558,0.453 1.906,0.98 l 0.051,0 0,-0.773 1.441,0 0,3.836 c 0,1.773 -1.324,2.765 -3.039,2.765 z m -0.18,-5.48 c -0.488,0 -1.168,0.242 -1.168,0.847 0,0.774 0.848,1.071 1.582,1.071 0.657,0 0.965,-0.145 1.364,-0.336 -0.117,-0.926 -0.914,-1.582 -1.778,-1.582 z m 8.469,5.261 -1.715,-4.335 -0.051,0 -1.773,4.335 -1.609,0 2.664,-6.058 -1.52,-3.371 1.559,0 4.105,9.429 -1.66,0 z M 93.547,16 l 1.496,0 0,10 -1.496,0 0,-10 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    fill: "url(#linearGradient50)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M 16.348,33.969 C 16.113,33.723 15.977,33.34 15.977,32.844 l 0,-17.692 c 0,-0.496 0.136,-0.879 0.371,-1.125 l 0.058,-0.054 9.914,9.91 0,0.234 -9.914,9.91 -0.058,-0.058 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path78",
    fill: "url(#linearGradient68)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 29.621,20.578 -3.301,3.305 0,0.234 3.305,3.305 0.074,-0.043 3.914,-2.227 c 1.117,-0.632 1.117,-1.672 0,-2.308 l -3.914,-2.223 -0.078,-0.043 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path88",
    fill: "url(#linearGradient82)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M 29.699,20.621 26.32,24 16.348,14.027 c 0.371,-0.39 0.976,-0.437 1.664,-0.047 l 11.687,6.641"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path104",
    fill: "url(#linearGradient92)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M 29.699,27.379 18.012,34.02 c -0.688,0.386 -1.293,0.339 -1.664,-0.051 L 26.32,24 l 3.379,3.379 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g122",
    mask: "url(#mask114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g148",
    clipPath: "url(#clipPath126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path152",
    fill: "url(#pattern134)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "g154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g170",
    mask: "url(#mask162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g196",
    clipPath: "url(#clipPath174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path200",
    fill: "url(#pattern182)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "g202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g218",
    mask: "url(#mask210)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g244",
    clipPath: "url(#clipPath222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path248",
    fill: "url(#pattern230)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "g250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g266",
    mask: "url(#mask258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g292",
    clipPath: "url(#clipPath270)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path296",
    fill: "url(#pattern278)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M 0,0 124,0 124,48 0,48 0,0 Z"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.3a46d261.svg";
export { ForwardRef as ReactComponent };